import starbucksLogoUrl from '@assets/StarbucksLogo.png';

interface LogoProps {
  className?: string;
  size?: number;
  title?: string;
}

const StarbucksLogo: React.FC<LogoProps> = ({
  className,
  size = 36,
  title = 'Starbucks',
}) => (
  <img
    src={starbucksLogoUrl}
    alt={title}
    width={size}
    height={size}
    className={className}
    style={{ objectFit: 'contain', display: 'block' }}
  />
);

export default StarbucksLogo;
